import Component from '@cell/cell-core/component/component';
import './filter.scss';

class Filter extends Component {
  constructor() {
    super();

    this.elements = {
      valueList: this.querySelector('.Filter__Values'),
      scrollInfo: this.querySelector('.ScrollInfo'),
    };

    this.handleFilterRemove = this.handleFilterRemove.bind(this);
    this.handleValueListScroll = this.handleValueListScroll.bind(this);
    this.handleDropdownContentOpened = this.handleDropdownContentOpened.bind(this);
    this.handleDropdownContentClosed = this.handleDropdownContentClosed.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.remove-filter', this.handleFilterRemove);

    globalThis.on('dropdown-content.opened', this.handleDropdownContentOpened);
    globalThis.on('dropdown-content.closed', this.handleDropdownContentClosed);
  }

  handleFilterRemove() {
    const url = this.querySelector('.Filter__Actions').getAttribute('data-url-to-remove');

    this.emit('remove-filter', { url });
  }

  handleValueListScroll() {
    this.elements.valueList.removeEventListener('scroll', this.handleValueListScroll);

    this.elements.scrollInfo?.hide();
  }

  handleDropdownContentOpened({ target }) {
    if (!this.contains(target)) return;

    // Scroll to the top of the value list.
    this.elements.valueList.scrollTop = 0;

    const checkScrollability = (element) => {
      // Content element is not (nor not enough) scrollable so there is no need to display a scroll info.
      if (element.clientHeight >= element.scrollHeight) {
        return;
      }

      window.requestAnimationFrame(() => {
        // Use `addEventListener` instead of `on` to we can remove the listener later on.
        // TODO: This should work with `on` as well in the future.
        element.addEventListener('scroll', this.handleValueListScroll);
      });

      setTimeout(() => {
        this.elements.scrollInfo?.show();
      }, 500);
    };

    checkScrollability(this.elements.valueList);
  }

  handleDropdownContentClosed() {
    this.elements.scrollInfo?.hide();
    this.elements.valueList.removeEventListener('scroll', this.handleValueListScroll);
  }
}

customElements.define('c-filter', Filter);
